var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    Precast building panels allow rapid construction, high strength and durability, and minimal maintenance issues.\n  ")]),_c('carousel',{attrs:{"item":"building-wall-panels","images":_vm.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }